const Definitions = {
    "on-demand-webinar": { alt:"On-Demand Webinar", title: "Webinars", type: "content" },
    "on-demand-webinar-2": { alt:"On-Demand Webinar Part 2", title: "Webinars", type: "content" },
    "e-manual": { alt:"E-Manual", title: "E-Manuals", type: "content" },
    "on-demand-workshop": { alt:"On-Demand Workshop", title: "Workshops", type: "content" },
    "on-demand-workshop-2": { alt:"On-Demand Workshop Indigenous Focus", title: "Workshops", type: "content" },
    shared: { title: "Shared", type: "sect" },
    member: { title: "Members", type: "sect" },
    library: { title: "Purchased", type: "sect" },
    expired: { title: "Expired", type: "sect" },
    contract: {title: 'Contract', type: 'sect'},
    free: {title: 'Free Content', type: 'sect'},
    all: { title: "All", type: "content" },
    membership: { title: "Membership", type: "content" },
    "e-course": { title: "E-Course", type: "content" },
    'certificate-self-guided': { title: 'Self-Guided Certificate', type: 'content' },
  };

  export default Definitions;